var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:{ 'ppv-wrap': _setup.cellType === 'band_61' }},[_c(_setup.isCatalogType ? _setup.CatalogLoader : _setup.DynamicSectionLoader,{tag:"component",attrs:{"catalog-info":_vm.catalog,"section-info":_setup.sectionInfo,"multisection-index":_vm.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }